import React, { useCallback, useContext } from 'react'
import { ObservationsContext } from '../../ObservationsContextContainer'
import HiddenClashesList from './HiddenClashesList';
import { Button } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

export default function HiddenClashes() {
    const observationsContext = useContext(ObservationsContext);
    const { t } = useTranslation("observations");

    const onHideAllVisibleClashesClicked = useCallback(() => {
        observationsContext.observationsStateDispatch({ type: 'forgetAllVisibleClashes' });
    }, []);

    return (
        <div>
            <p>
                {t("piilotetutTabiEkaRivi")}
            </p>
            <p>
                <Trans i18nKey="observations:piilotetutTabiTokaRivi">
                    <strong>HUOM!</strong> Konfliktia ei piiloteta eikä palauteta kartalle saman tien, vaan muutos näkyy vasta ladattaessa sivu uudelleen. Piilotukset ovat muistissa ainoastaan tässä selaimessa. Piilottaminen otetaan huomioon myös karttaa korkealta katsottuna näkyvässä ruudukkonäkymässä.
                </Trans>
            </p>
            <p>
                {t("piilotetutTabiKolmasRivi")}
                <Button onClick={onHideAllVisibleClashesClicked}>{t("piilotusNappi")}</Button>
            </p>
            {
                (!observationsContext.observationsState.clashesToForget || observationsContext.observationsState.clashesToForget.length === 0) && <>
                    <p>
                        {t("piilotetutTabiEiPiilotettuja")}
                    </p>
                    <b>{t("huomJosNappulaEiNäy")}</b>
                </>
            }
            {
                (observationsContext.observationsState.clashesToForget && observationsContext.observationsState.clashesToForget.length > 0) && <HiddenClashesList />
            }
        </div>
    )
}